/** Visual theme trial — reversible via localStorage */

export const VISUAL_THEME_KEY = 'visual_theme';

export type VisualTheme = 'classic' | 'soft' | 'youth';

export const VISUAL_THEME_OPTIONS: {
  value: VisualTheme;
  label: string;
  hint: string;
}[] = [
  {
    value: 'classic',
    label: 'Cũ (Classic)',
    hint: 'Giao diện hiện tại',
  },
  {
    value: 'soft',
    label: 'A · Soft Dashboard',
    hint: 'Hiện đại, card nhẹ, bảng gọn',
  },
  {
    value: 'youth',
    label: 'B · Youth Retail',
    hint: 'Trẻ, ấm, bắt mắt hơn',
  },
];

const THEME_CLASSES = ['visual-theme-soft', 'visual-theme-youth'];

export function getStoredVisualTheme(): VisualTheme {
  try {
    const v = localStorage.getItem(VISUAL_THEME_KEY);
    if (v === 'soft' || v === 'youth' || v === 'classic') return v;
  } catch {
    /* ignore */
  }
  // Default trial: Soft Dashboard (A). Đổi về classic nếu không ưng.
  return 'soft';
}

export function applyVisualTheme(theme: VisualTheme) {
  if (typeof document === 'undefined') return;
  THEME_CLASSES.forEach((c) => document.body.classList.remove(c));
  if (theme === 'soft') document.body.classList.add('visual-theme-soft');
  if (theme === 'youth') document.body.classList.add('visual-theme-youth');
  try {
    localStorage.setItem(VISUAL_THEME_KEY, theme);
  } catch {
    /* ignore */
  }
}
